import type { IconFontAwesomeProps } from "~components/IconFontAwesome";

interface ComputeButtonLinkIconRightArgs {
  iconLeft?: IconFontAwesomeProps["icon"];
}

export const computeButtonLinkIconLeft = ({
  iconLeft,
}: ComputeButtonLinkIconRightArgs) => {
  if (iconLeft) return iconLeft;

  return undefined;
};
